import React from 'react';
import { Crown, Star, Award } from 'lucide-react';
import { getLoyaltyTier, TIER_COLORS } from '../utils/loyalty';

const TIER_ICONS = { bronze: Award, silver: Star, gold: Crown, platinum: Crown };

/**
 * LoyaltyBadge — inline pill or icon-only chip.
 * Props: totalOrders (number), size = 'sm'|'md'|'lg', variant = 'pill'|'icon'
 */
export const LoyaltyBadge = ({ totalOrders = 0, size = 'sm', variant = 'pill', className = '' }) => {
  const tier = getLoyaltyTier(totalOrders);
  const colors = TIER_COLORS[tier.key];
  const Icon = TIER_ICONS[tier.key];

  const sizeClasses = {
    sm: { wrap: 'h-6 px-2 text-[10px] gap-1', icon: 'w-3 h-3' },
    md: { wrap: 'h-8 px-3 text-xs gap-1.5', icon: 'w-4 h-4' },
    lg: { wrap: 'h-10 px-4 text-sm gap-2', icon: 'w-5 h-5' },
  }[size];

  if (variant === 'icon') {
    return (
      <div
        className={`inline-flex items-center justify-center rounded-full ring-2 ring-white/40 shadow-md ${className}`}
        style={{
          background: `linear-gradient(135deg, ${colors.from}, ${colors.to})`,
          width: size === 'sm' ? 24 : size === 'md' ? 32 : 40,
          height: size === 'sm' ? 24 : size === 'md' ? 32 : 40,
        }}
        title={`${tier.label} — ${totalOrders} sipariş`}
        data-testid={`loyalty-badge-${tier.key}`}
      >
        <Icon className={sizeClasses.icon} style={{ color: colors.text }} />
      </div>
    );
  }

  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold tracking-wide uppercase shadow-sm ring-1 ring-white/30 ${sizeClasses.wrap} ${className}`}
      style={{
        background: `linear-gradient(135deg, ${colors.from}, ${colors.to})`,
        color: colors.text,
      }}
      title={`${tier.label} — ${totalOrders} sipariş`}
      data-testid={`loyalty-badge-${tier.key}`}
    >
      <Icon className={sizeClasses.icon} />
      {tier.label}
    </span>
  );
};

export default LoyaltyBadge;
